<template>
    <div v-if="nopower==true" class="nopower">
        <img src="../assets/images/icon-no-auth.png" alt />
        <p class="no-auth-text">您暂时无法访问系统</p>
        <p class="no-auth-text-span">如需访问，请提交账号开通流程，如已提交流程，请联系IT客服处理</p>
    </div>
</template>

<script>
    import api from '../api/oa'
    import Utils from '../utils/utils'
    import redirect from '@/webconfig'
    export default {
        name: "callBack.vue",
        data(){
            return {
                token:'',
                sid:'',
                code: '',
                PageUrl: '',
                nopower: false
            }
        },
        methods:{
            // 判断路由重定向
            getRoute() {
                this.code = Utils.getQueryString('code');
                if(!this.code) {
                    top.location.href = `${redirect.baseUrl}/profile/oauth2/authorize?client_id=${redirect.clientId}&redirect_uri=${redirect.redirectUri}&response_type=code&oauth_timestamp=${Math.round(new Date() / 1000)}`
                } else {
                    this.code = this.code.split('#')[0];
                    this.getOaRequire()
                }
            },
            getOaRequire(){
                let self = this
                let code = this.code
                api.gaoliUnionLogin({
                    code,
                }).then(res => {
                    if(res.data.code === 200) {
                        const data = res.data.data
                        Utils.setSession('userInfo', data);
                        Utils.setLocalStorage('userInfo', data);
                        Utils.setSession('posUserInfo', data);
                        Utils.setLocalStorage('posUserInfo', data);
                        if(this.$route.query.PageUrl != ''){
                            top.location.href = `${redirect.redirectUri}#/home?href=${this.$route.query.PageUrl}&oaCode=code&code=${this.code}`
                        } else{
                            top.location.href = `${redirect.redirectUri}#/home?oaCode=code&code=${this.code}`
                        }
                    }
                }).catch(err=>{
                    this.nopower = true
                })
            }
        },
        // beforeRouteEnter(to,from,next){
        //     let oaCode = Utils.getQueryString('code') || '';
        //     if(Utils.getLocalStorage('userInfo')){
        //         next()
        //     } else{
        //         next(vm=>{
        //             top.location.href = `${redirect.baseUrl}/login`
        //         })
        //     }
        // },
        created(){
            top.window.$message = this.$message; // 消息框
            this.getRoute()
        }
    }
</script>

<style scoped>

</style>